import { NavLink } from 'react-router-dom';
import { FiGrid, FiBox, FiShoppingBag, FiSettings, FiPlus, FiExternalLink } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import './VendorLayout.css';

const NAV = [
  { to: '/vendor/dashboard', icon: <FiGrid size={17} />, label: 'Dashboard' },
  { to: '/vendor/products', icon: <FiBox size={17} />, label: 'Products' },
  { to: '/vendor/orders', icon: <FiShoppingBag size={17} />, label: 'Orders' },
  { to: '/vendor/settings', icon: <FiSettings size={17} />, label: 'Settings' },
];

export default function VendorLayout({ children, title, action }) {
  const { vendor } = useAuth();
  const initial = vendor?.storeName?.[0]?.toUpperCase() || 'V';

  return (
    <div className="vlayout">
      {/* Sidebar */}
      <aside className="vlayout-sidebar">
        {/* Store identity */}
        <div className="vstore-header">
          <div className="vstore-logo">
            {vendor?.logo
              ? <img src={vendor.logo} alt={vendor.storeName} />
              : <span>{initial}</span>}
          </div>
          <div className="vstore-info">
            <p className="vstore-name">{vendor?.storeName || 'My Store'}</p>
            <span className={`badge ${vendor?.status === 'approved' ? 'badge-success' : vendor?.status === 'suspended' ? 'badge-danger' : 'badge-warning'}`}>
              {vendor?.status || 'pending'}
            </span>
          </div>
        </div>

        <nav className="vnav">
          {NAV.map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `vnav-item${isActive ? ' active' : ''}`}
            >
              {icon}
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="vsidebar-footer">
          <NavLink to="/vendor/products/add" className="btn btn-primary btn-sm btn-block">
            <FiPlus size={14} /> Add Product
          </NavLink>
          <a href="/" target="_blank" rel="noopener noreferrer" className="vstore-link">
            <FiExternalLink size={13} /> View Store
          </a>
        </div>
      </aside>

      {/* Content */}
      <main className="vlayout-main">
        {(title || action) && (
          <div className="vlayout-topbar">
            {title && <h1 className="vlayout-title">{title}</h1>}
            {action && <div className="vlayout-action">{action}</div>}
          </div>
        )}
        <motion.div
          key={title}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          {children}
        </motion.div>
      </main>
    </div>
  );
}
